// Định dạng hiển thị dùng chung (task 078): tiền VND "1.234.567 đ", số "1.234.567", ngày dd/MM/yyyy, giờ VN.
// Mọi màn loyalty/khách/voucher dùng các hàm này thay vì tự gọi Intl/toLocaleString/dayjs.format.

const VN_TZ = 'Asia/Ho_Chi_Minh';
const nf = new Intl.NumberFormat('vi-VN');

/** Số nguyên có dấu chấm ngăn nghìn: 1234567 → "1.234.567". null/NaN → "—". */
export function formatNumber(v: number | string | null | undefined): string {
  const n = typeof v === 'string' ? Number(v) : v;
  if (n == null || !Number.isFinite(n)) return '—';
  return nf.format(Math.round(n));
}

/** Tiền VND: 1234567 → "1.234.567 đ". null/NaN → "—". */
export function formatVnd(v: number | string | null | undefined): string {
  const s = formatNumber(v);
  return s === '—' ? s : `${s} đ`;
}

/** Phần trăm, tối đa `digits` số lẻ (mặc định 1): 12.34 → "12,3%". */
export function formatPercent(v: number | null | undefined, digits = 1): string {
  if (v == null || !Number.isFinite(v)) return '—';
  return `${new Intl.NumberFormat('vi-VN', { maximumFractionDigits: digits }).format(v)}%`;
}

function parse(raw: Date | string | number | null | undefined): Date | null {
  if (raw == null || raw === '') return null;
  // Postgres "2026-07-23 16:35:16+00" → ISO đầy đủ để mọi trình duyệt parse đúng
  const v = typeof raw === 'string' ? raw.trim().replace(' ', 'T').replace(/(T[\d:.]+)([+-]\d{2})$/, '$1$2:00') : raw;
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

function parts(d: Date, withTime: boolean): string {
  const o: Intl.DateTimeFormatOptions = { timeZone: VN_TZ, day: '2-digit', month: '2-digit', year: 'numeric' };
  if (withTime) Object.assign(o, { hour: '2-digit', minute: '2-digit', hour12: false });
  const m = Object.fromEntries(new Intl.DateTimeFormat('en-GB', o).formatToParts(d).map((p) => [p.type, p.value]));
  const date = `${m.day}/${m.month}/${m.year}`;
  return withTime ? `${date} ${m.hour === '24' ? '00' : m.hour}:${m.minute}` : date;
}

/** Ngày theo giờ Việt Nam: "04/04/1979". Rỗng/không đọc được → "—". */
export function formatDate(raw: Date | string | number | null | undefined): string {
  // Chuỗi chỉ-ngày (YYYY-MM-DD): là ngày lịch, không đổi múi giờ.
  if (typeof raw === 'string') {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw.trim());
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  }
  const d = parse(raw);
  return d ? parts(d, false) : '—';
}

/** Ngày giờ theo giờ Việt Nam: "04/10/2026 09:29". */
export function formatDateTime(raw: Date | string | number | null | undefined): string {
  const d = parse(raw);
  return d ? parts(d, true) : '—';
}

/** Email do hệ thống sinh (zalo+…@…zalo.invalid, demo-…@…invalid): không nên hiển thị cho người xem. */
export function isPlaceholderEmail(e?: string | null): boolean {
  return !!e && /\.invalid$/i.test(e.trim());
}
